module.exports = __webpack_public_path__ + "img/guinea-bissau.b8947579.svg";